import { Link, useLocation } from 'react-router';

import type { CreditNote } from '~/api/creditNotes/types';

import { useClientsWithTrashed } from '~/api/clients';
import { SearchParamKeys } from '~/constants/url';
import { r, routes } from '~/providers/RouterProvider/router.routes';
import { cellLinkStyle, desktopTruncateStyle } from '~/styles/utilities.css';
import { clsx } from '~/styles/utils';
import { qs } from '~/utils/searchParams';

type Props = {
  creditNote: CreditNote;
};

export const CreditNoteClientCell = ({ creditNote }: Props) => {
  const { data: clients } = useClientsWithTrashed();
  const { pathname } = useLocation();

  const client = clients.find(({ id }) => id === creditNote.clientId);

  if (!client) return '–';

  if (client.deleted) return <div className={desktopTruncateStyle}>{client.name}</div>;

  if (client.clientType === 'private' && !client.contacts[0]) {
    return <div className={desktopTruncateStyle}>{client.name}</div>;
  }

  const to =
    client.clientType === 'organisation'
      ? r(routes.showClient, { clientId: client.id })
      : r(routes.editContact, { clientId: client.id, contactId: client.contacts[0].id });

  return (
    <div className={desktopTruncateStyle}>
      <Link
        className={clsx(cellLinkStyle, desktopTruncateStyle)}
        to={{ pathname: to, search: qs({ [SearchParamKeys.REDIRECT_PATH]: pathname }) }}
      >
        {client.name}
      </Link>
    </div>
  );
};
